export default function() {
    return {
        symplaTokens: [],
        fields: [
            {
                key: 'name',
                label: 'Nome'
            },
            {
                key: 'events',
                label: 'Eventos'
            },
            {
                key: 'token',
                label: 'Token'
            },
            {
                key: 'actions',
                label: 'Ações'
            }
        ]
    }
}
